module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"date_format":"Date format","enter_date_format":"Please enter the date format"},"fr":{"date_format":"Format de date","enter_date_format":"Entrez le format de date"}}')
  delete Component.options._Ctor
}
